import { ResolveFn } from '@angular/router';
import { forkJoin, map, Observable, switchMap, tap } from 'rxjs';
import { IndicatorsService } from '../services/indicators.service';
import { inject } from '@angular/core';
import { StrategyService } from '../services/strategy.service';

export const strategicIndicatorResolver: ResolveFn<Observable<any>> = (route, state) => {
  const strategyService = inject(StrategyService);
  const strategyId = route.params['strategyId'];
  if (!+strategyId) {
    return strategyService.defaultStrategy$.pipe(switchMap((strategy: any) => {
      return forkJoin({
        strategies: strategyService.RawStrategies$
      }).pipe(map(({ strategies }) => {
        return {

          strategies,
          strategy
        };
      }))
    }))
  } else {
    return forkJoin({
      strategies: strategyService.RawStrategies$,
      strategy: strategyService.getStrategyById(strategyId.toString())
    })
  }
};
